var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitnami(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 142,
    viewBox: "0 0 127 142",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bitnami-Logo-Full-Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.244 76.155C2.72 73.543.304 70.957.304 65.835v-58.3c0-2.664.71-5.061 1.858-7.09l24.537 14.1V87.39L7.244 76.155z",
    id: "bma"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "18.01%",
    y1: "80.098%",
    x2: "77.804%",
    y2: "28.779%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093266",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.741 48.056L.453 43.271V12.79l15.349 8.861L52.318.571V.436l24.635 14.156c-1.188 2.158-2.96 3.944-5.292 5.29L22.878 48.047a14.114 14.114 0 0 1-7.075 1.917 14.11 14.11 0 0 1-7.062-1.908",
    id: "d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    y2: "50%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3984B5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.05 62.437L63.724 53.59l-15.326 8.848 15.326 8.935z",
    fill: "#00577B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.724 88.989l15.326-8.851v-17.7l-15.326 8.85z",
    fill: "#1E384B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.724 88.989l-15.326-8.851v-17.7l15.326 8.85z",
    fill: "#15211F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.24 50.419V92.45l-36.516 21.083-36.52-21.083v-.063l-24.536 14.1c1.286 2.27 3.121 4.075 5.153 5.249 16.194 9.348 32.385 18.699 48.58 28.047 4.753 2.745 9.868 2.758 14.594.03l48.698-28.117c4.546-2.624 6.943-6.789 6.943-12.085v-56.03c0-2.756-.602-5.214-1.761-7.32L100.24 50.42z",
    fill: "#00437C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 .506 106.933)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bmb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bma"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bmb)",
    fill: "url(#c)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.244 76.155C2.72 73.543.304 70.957.304 65.835v-58.3c0-2.664.71-5.061 1.858-7.09l24.537 14.1V87.39L7.244 76.155z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 47.922 50.854)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)",
    fill: "url(#f)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.741 48.056L.453 43.271V12.79l15.349 8.861L52.318.571V.436l24.635 14.156c-1.188 2.158-2.96 3.944-5.292 5.29L22.878 48.047a14.114 14.114 0 0 1-7.075 1.917 14.11 14.11 0 0 1-7.062-1.908"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitnami);
export default __webpack_public_path__ + "static/media/bitnami.d8cb78d10b9e80ac73f2ffb80856cf8f.svg";
export { ForwardRef as ReactComponent };